import * as models from './model';

export interface VisualFilter {
    name?: string;
    attributes?: string[];
    globalAttributes?: string[];
}
